<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <div v-if="$route.meta.keepAlive" id="nav" :class="[register ? 'widthTop' : '']"
        :style="{ left: -scrollLeft + 'px' }">
        <div class="nav color10" @click="seachShow = false">
          <div class="flex_ac">
            <img style="width:109px;height:30px" src="./assets/img/img-title.png" type="flex" justify="space-around"
              align="middle">
          </div>
          <div class="flex_ac">
            <img style="width:114px;height:69px" src="./assets/img/logo-title.png" type="flex" justify="space-around"
              align="middle">
          </div>
          <div class="nav_list">
            <div :class="`${$i18n.locale == 'zh-cn' ? 'main-font20' : 'fs16'} cp`">
              <router-link :class="{ a_none: true, isActive: active == 0 }" @click.native="changeActive(0)" to="/">{{
                $t('title.home') }}</router-link>
            </div>
            <div :class="`${$i18n.locale == 'zh-cn' ? 'main-font20' : 'fs16'} cp`">
              <router-link :class="{ a_none: true, isActive: active == 1 }" @click.native="changeActive(1)"
                to="/product">{{
                  $t('title.productCenter') }}</router-link>
            </div>
            <div :class="`${$i18n.locale == 'zh-cn' ? 'main-font20' : 'fs16'} cp`">
              <router-link :class="{ a_none: true, isActive: active == 2 }" @click.native="changeActive(2)"
                to="/video">{{
                  $t('title.applicationVideo') }}</router-link>
            </div>
            <div :class="`${$i18n.locale == 'zh-cn' ? 'main-font20' : 'fs16'} cp`">
              <router-link :class="{ a_none: true, isActive: active == 3 }" @click.native="changeActive(3)"
                to="/about">{{
                  $t('title.aboutDongju') }}</router-link>
            </div>
            <div :class="`${$i18n.locale == 'zh-cn' ? 'main-font20' : 'fs16'} cp`">
              <router-link :class="{ a_none: true, isActive: active == 4 }" @click.native="changeActive(4)"
                to="/contact">{{
                  $t('title.contactUs') }}</router-link>
            </div>
            <div :class="`${$i18n.locale == 'zh-cn' ? 'main-font20' : 'fs16'} cp`">
              <a-dropdown>
                <a :class="{ a_none: true, isActive: active == 5 }" @click="e => e.preventDefault()">
                  {{ $t('title.downloadCenter') }} <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <router-link @click.native="changeActive(5)" to="/download">{{ $t('title.cpzl') }}</router-link>
                  </a-menu-item>
                  <a-menu-item>
                    <router-link @click.native="changeActive(5)" to="/debug">{{ $t('title.rjxz') }}</router-link>
                  </a-menu-item>
                  <a-menu-item>
                    <router-link @click.native="changeActive(5)" to="/other">{{ $t('title.qtwj') }}</router-link>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
            <div class="lang">
              <img style="width:20px;height:20px" class="mar_r5" src="./assets/img/stLine-network.png" type="flex"
                justify="space-around" align="middle">
              <div class="cp color48" @click="onChange('zh')">中文</div>
              <div style="margin:3px">/</div>
              <div class="cp color48" @click="onChange('en')">En</div>
            </div>
          </div>
          <div class="flex_ac">
            <div class="mainbg flex_ac"
              style="color:white;height:30px;border-radius: 50px;padding:0 10px; width: 100%;">
              <img style="width:20px;height:20px" class="mar_r5" src="./assets/img/user.png" type="flex"
                justify="space-around" align="middle">
              <div class="cp" @click="showRegist">{{ $t('title.register') }}</div>
              <div style="margin:3px">|</div>
              <div class="cp" @click="showLogin">{{ $t('title.login') }}</div>
            </div>
          </div>
          <div class="borderRa flex_ac">
            <a-input @change="SeachValue" @pressEnter="Seach" style="border-radius: 50px;" ref="userNameInput"
              v-model="searchvalue" :placeholder="$t('title.search')">
              <a-icon style="color:white" slot="prefix" type="user" />
            </a-input>
          </div>
        </div>
      </div>
      <router-view v-if="$route.meta.keepAlive" />
      <router-view v-if="!$route.meta.keepAlive" />
      <div>
        <div class="flex_" style="height:240px;background:#242424;color: rgba(255, 255, 255, 1);font-size: 18px;">
          <div style="width: 40%;" class="flex_">
            <div style="padding-left:120px">
              <img style="width:114px;height:119px;" :src="'http://' + wechartImg">
              <div class="text-center main-font16 mar_t8">{{ $t('title.wxkf') }}</div>
            </div>
            <div style="margin-left:60px">
              <div class="main-font20 text-center" style="width: 103px;margin-bottom:15px;">{{ $t('title.kfzx') }}</div>
              <div class="zixun" v-for="(item, i) in qqList.slice(0, 3)" :key="i">
                <a :href="'http://wpa.qq.com/msgrd?v=3&uin=' + item + '&site=qq&menu=yes'" target="_blank"
                  style="color:#262525">
                  <img style="width:27;height:27px" src="./assets/img/qq-line.png">
                  咨询{{ i + 1 }}
                </a>
              </div>
            </div>
          </div>
          <div style="width:2px">
            <img style="height:206px" src="./assets/img/line.png" type="flex" justify="space-around" align="middle">
          </div>
          <div style="margin-left:90px">
            <div style="font-size: 24px;">{{ $t('title.contactUs') }}</div>
            <div style="font-size: 15px;">contact</div>
            <div class="flex_ac contactUs">
              <div class="us_left">
                <div class="flex_ac mar_b5"><img src="./assets/img/phone_s.png" alt="">{{ $t('member.lxdh')
                }}：{{ address.tel }}</div>
                <div class="flex_ac mar_b5"><img src="./assets/img/e-mails.png" alt="">{{ $t('title.email')
                }}：{{ address.email }}</div>
                <div class="flex_fs mar_b5"><img src="./assets/img/address-com.png" alt=""><span class="nowrap">{{
                  $t('title.address') }}：</span> <span>{{ $store.state.langStates ==
                      'zh' ? address.address : address.address_en }}</span></div>
                <div class="flex_ac mar_b5 nowrap"><img src="./assets/img/friend.png" alt="">
                  {{ $t('title.fl') }}：<a style="text-decoration:none;color:white" href="http://mackcorp.com"
                    target="blank_">mackcorp.com</a>
                  <span class="mar_l30"></span>
                  {{ $t('title.eemail') }}：info@mackcorp.com
                </div>
              </div>
              <div style="font-size: 20px;">
                <div style="margin: 10px 0;"><router-link style="color:white;" to="/about"
                    @click.native="changeActive(3)">{{ $t('title.aboutDongju') }}</router-link></div>
                <div style="margin: 10px 0;"><router-link style="color:white;" to="/download"
                    @click.native="changeActive(5)">{{ $t('title.downloadCenter') }}</router-link></div>
              </div>
            </div>
          </div>
        </div>
        <div style="height:56px;line-height:56px" class=" text-center">@2020 {{ address.company }} 版权所有 <a
            href="https://beian.miit.gov.cn" style="color:#242424;">备案号：蜀ICP备15006437号-1</a></div>
      </div>
      <!-- 在线咨询 -->
      <div class="online">
        <div v-if="onLineShow" class="main-font20 btn" @click="onLineShow = false">
          <p>{{ $t('title.online') }}</p>
        </div>
        <div v-else class="btnshow">
          <div class="text-right" style="margin: 4px;" @click.stop="onLineShow = true">
            <a-icon type="close-circle" style="font-size: 20px;color: #999;" />
          </div>
          <div class="qq">
            <img src="./assets/img/QQ.png">
            <p>QQ在线咨询</p>
            <a v-for="(item, i) in qqList.slice(0, 3)" :key="i"
              :href="'http://wpa.qq.com/msgrd?v=3&uin=' + item + '&site=qq&menu=yes'" target="_blank">{{ item }}</a>
          </div>
          <p>咨询热线</p>
          <p>13700948080</p>
          <div class="icon">
            <a-popover placement="leftBottom">
              <template slot="content">
                <div class="text-center">
                  <img :src="'http://' + wechart[0]" style="width: 100px;height: 100px;">
                  <div style="padding: 10px 0;">微信扫一扫</div>
                  <div>添加微信在线客服</div>
                </div>
              </template>
              <div style="border-right: 1px solid #f1f1f1;">
                <a-icon type="qrcode" />
              </div>
            </a-popover>
            <div @click="backTop"><img src="./assets/img/backtop.png"></div>
          </div>
        </div>
      </div>
      <!-- 加入购物车 -->
      <div v-if="$store.state.token" class="addcar">
        <router-link to="/shoppingcar">
          <a-icon type="shopping-cart" />
        </router-link>
      </div>
      <!-- 注册弹窗 -->
      <a-modal v-model="register" :closable="true" :footer="null" width="640px" :destroy-on-close="true"
        wrap-class-name="register" @cancel="closeModal">
        <div class="r_info">
          <div class="title main-font30 text-center">{{ $t('title.register') }}</div>
          <div class="info">
            <a-form :form="form" label-align="left" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }"
              @submit="Register">
              <a-form-item :label-col="{ span: 12, offset: 8 }" :wrapper-col="{ span: 9, offset: 8 }">
                <a-radio-group v-decorator="['type', { initialValue: 'engineer' }]" name="type">
                  <a-radio value="engineer"> {{ $t('title.engineer') }} </a-radio>
                  <a-radio value="purchase"> {{ $t('title.purchase') }} </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item :label="$t('title.CompanyName')">
                <a-input v-decorator="['company', { rules: [{ required: true, message: $t('tips.r1') }] },]"
                  placeholder="" />
              </a-form-item>
              <a-form-item :label="$t('title.address')">
                <a-input v-decorator="['address', { rules: [{ required: true, message: $t('tips.r2') }] },]"
                  placeholder="" />
              </a-form-item>
              <a-form-item :label="$t('title.contacts')">
                <a-input v-decorator="['contact_name', { rules: [{ required: true, message: $t('tips.r3') }] },]"
                  placeholder="" />
              </a-form-item>
              <a-form-item :label="$t('title.phone')">
                <a-input v-decorator="['phone', { rules: [{ required: true, message: $t('tips.r4') }] },]"
                  placeholder="" />
              </a-form-item>
              <a-form-item :label="$t('title.email')">
                <a-input
                  v-decorator="['email', { rules: [{ required: true, message: $t('tips.r5') }, { type: 'email', message: $t('tips.r8') }] },]"
                  placeholder="" />
              </a-form-item>
              <a-form-item :label="$t('title.nikename')">
                <a-input
                  v-decorator="['name', { rules: [{ required: true, message: $t('tips.r6') }, { validator: compareToName }] },]"
                  placeholder="" />
              </a-form-item>
              <a-form-item :label="$t('title.pwd')">
                <a-input
                  v-decorator="['password', { rules: [{ required: true, message: $t('tips.r7'), }, { validator: compareToPassword, },], },]"
                  placeholder="" />
              </a-form-item>
              <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                <div style="width: 100%; height: 20px;" />
                <a-row type="flex" justify="space-around" align="middle">
                  <a-col :span="17">
                    <div class="r_btn">
                      <a-button type="primary" html-type="submit" shape="round" block> {{ $t('title.register') }}
                      </a-button>
                    </div>
                  </a-col>
                  <a-col :span="7">
                    {{ $t('title.yyzh') }}？<a style="color: #1F5EA5;" @click="showLogin">{{ $t('title.ljdl') }}</a>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </a-modal>
      <!-- 登录弹窗 -->
      <a-modal v-model="login" :closable="true" :footer="null" width="640px" :destroy-on-close="true"
        wrap-class-name="register" @cancel="closeModal">
        <div class="l_info">
          <div class="title main-font30 text-center">{{ $t('title.login') }}</div>
          <div class="info">
            <a-form :form="loginform" @submit="LoginSubmit">
              <a-form-item>
                <a-input v-decorator="[
                  'name',
                  { initialValue: registerInfo.name },
                  { rules: [{ required: true, message: $t('tips.l1') }] },
                ]" :placeholder="$t('tips.r6')">
                  <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input v-decorator="[
                  'password',
                  { initialValue: registerInfo.password },
                  { rules: [{ required: true, message: $t('tips.l2') }] },
                ]" type="password" :placeholder="$t('tips.r7')">
                  <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <div class="r_btn">
                  <a-button type="primary" html-type="submit" shape="round" block> {{ $t('title.login') }} </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </a-modal>
    </div>
  </a-config-provider>
</template>

<script>
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement('script');
  hm.src = 'https://hm.baidu.com/hm.js?8cc6cd7b160361d723cd1910583a0f04';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import moment from 'moment'
  import { mapState, mapMutations } from "vuex"
  import 'moment/locale/zh-cn'
  moment.locale('zh-cn')
  const EN = 'en-us'
  const ZH = 'zh-cn'
  export default {
    data() {
      return {
        lbw: '100%',
        seachShow: false,
        onLineShow: true,
        register: false,
        registerInfo:{
          name:'',
          password:''
        },
        checkNick: false,
        login: false,
        form: this.$form.createForm(this, {
          name: 'dynamic_rule'
        }),
        loginform: this.$form.createForm(this, {
          name: 'dynamic_rule'
        }),
        user: false,
        locale: zhCN,
        langValue: 'zh',
        qqList: '',
        qqhref: '',
        banner: '',
        scrollLeft: 0,
        searchvalue: '',
				wechart:'',
        wechartImg:'',
        address:'',
        // active:0
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮滚动事件
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll) //  离开页面清除（移除）滚轮滚动事件
    },
    computed:{
      ...mapState(['active'])
    },
    created() {
      let lang = this.$store.state.langStates
      this.$api.dongjuapi.index(lang, {
        lang
      }).then(res => {
        this.banner = res.data.data.banner
        this.wechart = res.data.data.customer_service.wehcat_image
        this.wechartImg = res.data.data.customer_service.wehcat_image[1]
        this.qqList = res.data.data.customer_service.qq
        this.qqhref = 'http://wpa.qq.com/msgrd?v=3&uin=' + res.data.data.customer_service.qq[0] +
          '&site=qq&menu=yes'
      }).catch(err => {

      })
      this.getAddress()
    },
    methods: {
      ...mapMutations(['changeA']),
      getAddress(){
        this.$api.dongjuapi.getAddress().then(res=>{
          if(res.data.code == 200){
            this.address = res.data.data
          }
        })
      },
      handleScroll() {
        this.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
      },
      SeachValue(e) {
        this.searchvalue = e.target.value
      },
      Seach() {
        if (!this.seachShow) {
          this.seachShow = true
        }
        console.log(this.searchvalue)
        if (this.seachShow && this.searchvalue) {
          sessionStorage.setItem('searchKey', this.searchvalue)
          this.$router.push({
            path: '/product'
          }).then(()=>{
              this.changeActive(1)
          }).catch(err => {
            this.$router.go(0)
          })
        }
      },
      onChange(e) {
        if (e === 'en') {
          moment.locale(EN)
          this.$i18n.locale = EN
          this.langValue = 'en'
          this.locale = null
          this.$store.commit('updateLang', 'en')
        } else {
          moment.locale(ZH)
          this.$i18n.locale = ZH
          this.langValue = 'zh'
          this.$store.commit('updateLang', 'zh')
          this.locale = zhCN
        }
      },
      //返回顶部
      backTop() {
        let top = document.documentElement.scrollTop || document.body.scrollTop
        // 实现滚动效果
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 50
          if (top <= 0) {
            clearInterval(timeTop)
          }
        }, 10)
      },
      showRegist() {
        this.register = true;
        this.lbw = 'calc(100% - 17px)'
      },
      closeModal() {
        this.lbw = '100%'
      },
      // 注册
      Register(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          if (!err) {
            this.$api.dongjuapi.register(values).then(res => {
              if (res.data.code == 200) {
                this.$message.success('注册成功', 1)
                console.log(res.data)
                this.register = false
                this.login = true;
                this.lbw = 'calc(100% - 17px)'
                this.registerInfo.name = values.name
                this.registerInfo.password = values.password
              }
            }).catch(err => {
              this.$message.error(err.data.message)
            })
          }
        });
      },
      compareToPassword(rule, value, callback) {
        const reg = /^[0-9a-zA-Z]{8,12}$/
        if (value && !reg.test(value)) {
          callback('请输入数字和英文组成的8~12位密码！');
        } else {
          callback();
        }
      },
      compareToName(rule, value, callback) {
        const reg = /^[A-Za-z0-9\u4E00-\u9FA5-]{3,60}$/
        if (value && !reg.test(value)) {
          callback('用户名必须介于3 - 60个字符之间。！');
        } else {
          callback();
        }
      },
      // 打开登录弹窗
      showLogin() {
        this.register = false
        this.login = true;
        this.lbw = 'calc(100% - 17px)'
      },
      // 登录
      LoginSubmit(e) {
        e.preventDefault();
        this.loginform.validateFields((err, values) => {
          console.log('登录信息',values)
          if (!err) {
            this.$api.dongjuapi.login(values).then(res => {
              this.user = true
              this.login = false
              const token = res.data.data.token_type + ' ' + res.data.data.token
              localStorage.setItem("token", token)
              this.$store.commit('updateToken', token)
              this.$message.success('登录成功', 1)
            }).catch(err => {
              console.log(err)
              // this.$message.error(err.data.message)
            })
          }
        });
      },
      wxBtn(e){
        this.wechartImg = this.wechart[e]
      },
      changeActive(v){
        this.changeA(v)
      }
    }
  };
</script>

<style lang="less">
.b_box {
  height: 240px;
  padding-top: 38px;
}

body {
  position: relative;
  max-width: 100vw !important;
  // overflow-x: hidden;
}

.lunbo {
  width: 100%;
  margin-top: 75px;
}

.ant-carousel {
  .slick-slide {
    text-align: center;
    height: 600px;
    overflow: hidden;

    img {
      width: 100%;
      height: 600px;
    }
  }
}

.dot {
  margin-bottom: 10px !important;

  li {
    margin: 0 5px !important;

    button {
      width: 10px !important;
      height: 10px !important;
      background: #333 !important;
      border-radius: 50% !important;
    }
  }
}

.lang {
  .ant-radio-wrapper {
    color: #fff;
  }
}

.ant-col-6 {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between;
}

.usercenter {
  a {
    margin-right: 0 !important;
  }
}

.register {
  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close-x {
    color: #fff;
    font-size: 24px;
  }

  .r_info {
    height: auto;

    .info {
      padding: 30px 50px;

      .r_btn {
        width: 360px;

        .ant-btn {
          height: 50px;
        }
      }
    }
  }

  .l_info {
    height: auto;

    .info {
      padding: 50px 120px;

      .r_btn {
        width: 400px;
        margin-top: 20px;

        .ant-btn {
          height: 50px;
          font-size: 16px !important;
        }
      }
    }
  }

  .title {
    width: 100%;
    height: 100px;
    background: #1F5EA5;
    color: #fff;
    line-height: 100px;
  }

  .info {
    width: 100%;
    height: auto;
  }
}

@import './assets/main.less';

#app {
  width: 100%;
  max-width: 1600px;
  min-width: 1200px;
  margin: 0 auto;
  font-family: SYHT;
  -webkit-font-smoothing: SYHT;
  -moz-osx-font-smoothing: SYHT;
  color: #101010;
  background: #f1f1f1;
}

#nav {
  width: 100vw;
  padding-right: 17px;
  height: 75px;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  .nav {
    width: 100%;
    height: 100%;
    max-width: 1600px;
    min-width: 1200px;
    background-color: rgba(255, 255, 255, 1);
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 20px;
    display: grid;
    grid-template-columns: 170px 130px 1fr 120px 120px;
    grid-column-gap: 20px;

    a {
      color: rgba(29, 32, 36, 1);
      // display: inline-block;
      // line-height: 80px;
      // font-size: 20px;
      // margin-right: 30px;

      &.router-link-exact-active {
        text-decoration: none;
      }
    }

    .top {
      >div {
        height: 100%;
      }

      img {
        width: 526px;
        height: auto;
      }
    }

    .nav_list {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 150px;
      place-items: center;

      .cp {
        text-align: center;
      }

      .lang {
        // width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
      }
    }

    .borderRa {
      .ant-input-affix-wrapper {
        .ant-input {
          background-color: #1F5EA5;
          color: white;
          border-radius: 50px;
        }
      }

    }
  }

  @media (max-width: 1410px) {
    .nav {
       grid-template-columns: 110px 120px 1fr 120px 120px;
       .nav_list{
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 100px 100px;
       }
    }
  }
}

.widthTop {
  // width: calc(100% - 17px) !important;
}

.footer {
  width: 100%;
  min-height: 300px;

  .one {
    width: 100%;
    height: 240px;

    .main-center {
      width: 1200px;
    }

    .ant-row-flex {
      height: 240px;
    }

    img {
      width: 100px;
      height: 100px;
      background: #000;
      margin-bottom: 10px;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    a {
      text-decoration: underline;
      font-size: 20px;
    }
  }

  .two {
    width: 100%;
    height: 60px;
    line-height: 60px;
  }

  .ant-btn {
    width: 140px;
    border-radius: 4px;
  }
}

.addcar {
  position: fixed;
  right: 16px;
  bottom: 50%;
  width: 60px;
  height: 60px;
  background: #1F5EA5;
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 36px;
  border-radius: 50%;

  a {
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
}

.online {
  width: auto;
  height: auto;
  position: fixed;
  right: 16px;
  text-align: center;
  bottom: 196px;
  z-index: 999;

  .btn {
    width: 60px;
    height: 180px;
    background: #1F5EA5;
    color: #fff;
    position: relative;
    text-align: center;
    cursor: pointer;

    p {
      width: 60px;
      height: 180px;
      line-height: 60px;
      writing-mode: tb-lr;
      writing-mode: vertical-lr;
      margin: 0 !important;
    }
  }

  .btn::before {
    content: '+';
    color: #1F5EA5;
    width: 36px;
    height: 36px;
    line-height: 24px;
    border: 4px solid #1F5EA5;
    border-radius: 50%;
    font-weight: bold;
    background: #fff;
    font-size: 30px;
    position: absolute;
    top: -18px;
    left: 12px;
  }

  .btnshow {
    width: 120px;
    min-height: 306px;
    border-radius: 4px;
    background: #fff;
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    text-align: center;
    border: 1px solid rgba(187, 187, 187, 1);

    .qq {
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
      }

      a {
        padding-bottom: 10px;
        display: block;
      }

      p:nth-child(2) {
        font-size: 16px;
        color: #1F5EA5;
        padding: 10px 0 10px;
        margin: 0;
      }

      border-bottom: 1px solid #f1f1f1;
    }

    p:nth-child(3) {
      margin-top: 20px !important;
      font-weight: bold;
    }

    p:nth-child(4) {
      margin-bottom: 0 !important;
      padding-bottom: 20px;
      border-bottom: 1px solid #f1f1f1;
    }

    .icon {
      line-height: 51px;
      color: #999;
      font-size: 30px;
      display: flex;
      align-items: center;

      div {
        width: 50%;
        height: 51px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      img {
        width: 30px;
        height: 30px;
      }
    }
  }
}

.zixun {
  width: 103px;
  height: 30px;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #262525;
  margin-bottom: 18px;
}

.mainbg {
  background-color: #1F5EA5;
  flex-wrap: nowrap;
}

.isActive {
  color: rgba(31, 94, 165, 1) !important;
}

.contactUs {
  margin-top: 12px
}

.us_left {
  font-size: 18px;
  width: 360px;
  margin-right: 130px;

  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}
</style>